import { Component, OnInit } from '@angular/core';
import {NbWindowRef} from '@nebular/theme';

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.css']
})
export class WindowComponent implements OnInit {

  constructor(protected windowRef: NbWindowRef) { }

  ngOnInit(): void {
  }

}
